module.exports = __webpack_public_path__ + "static/media/OCFL-News-Page-Needs-1.7d41823c.png";